// MARK: React
import * as React from "react";
import "./style.scss";

// MARK: Mobx
import { observer } from "mobx-react";

// MARK: Api
import { Image } from "@startapp/mistral-admin-api";

// MARK: Components
import { TableCell as MTableCell } from "@material-ui/core";
import { IconButton as MIconButton } from "@material-ui/core";
import { TableRow as MTableRow } from "@material-ui/core";

// MARK: Icons
import { Edit as MEditIcon } from "@material-ui/icons";
import { Delete as MDeleteIcon } from "@material-ui/icons";
import { Search as MDetailsIcon } from "@material-ui/icons";

export enum ColumnType {
	image,
	avatar,
	text,
	link,
	boolean,
}

export interface IRowItem {
	id: string;
	name: string;
	columns: IColumnItem[];
}

export interface IColumnItem {
	type?: ColumnType;
	// tslint:disable-next-line: max-union-size
	value: string | ILinkValue | Image | null;
}

interface ILinkValue {
	src: string;
	name: string;
}

interface IProps {
	rowItem: IRowItem;
	onClick?: (id: string) => void;
	onEditClick?: (id: string) => void;
	onDetailsClick?: (id: string) => void;
	onDeleteClick?: (id: string, name: string) => void;
}

@observer
export default class TableRow extends React.Component<IProps> {
	/**
	 * Each item of the array is a column value in the in the Table row
	 * with you choose to add a edit/delete buttonm make sure adding -1 item on the
	 * data array, to the row matches with the header size.
	 */

	public render() {
		const { rowItem, onEditClick, onDeleteClick, onDetailsClick, onClick } = this.props;

		return (
			<MTableRow hover={true} tabIndex={-1} onClick={() => onClick && onClick(rowItem.id)}>
				{
					/**
					 * The additional Cell will only be placed if
					 * there is one of the callback functions: "onEditClick"
					 * or "onDeleteClick"
					 */
					(onEditClick || onDeleteClick) && (
						<MTableCell
							key={`${rowItem.id}-edit-or-delete`}
							align="center"
						>
							{onEditClick && (
								<MIconButton
									onClick={(event) => {
										event.stopPropagation();
										onEditClick(rowItem.id);
									}}
								>
									<MEditIcon />
								</MIconButton>
							)}
							{onDeleteClick && (
								<MIconButton
									onClick={(event) => {
										event.stopPropagation();
										onDeleteClick(rowItem.id, rowItem.name);
									}}
								>
									<MDeleteIcon />
								</MIconButton>
							)}
							{onDetailsClick && (
								<MIconButton
									onClick={(event) => {
										event.stopPropagation();
										onDetailsClick(rowItem.id);
									}}
								>
									<MDetailsIcon />
								</MIconButton>
							)}
						</MTableCell>
					)
				}
				{
					rowItem.columns.map((columnValue, index) => {
						return (
							<MTableCell
								className="tableCell"
								key={`${rowItem.id}${index}`}
								align="center"
							>
								{(() => {
									switch (columnValue.type) {
										case ColumnType.avatar: {
											return (
												<div className="roundImageContainer">
													<img className="roundImage" src={columnValue.value as string || "/userPlaceholder.svg"} alt="avatar-image" />
												</div>
											);
										}
											break;
										case ColumnType.image: {
											return (
												<div className="roundImageContainer">
													<img className="roundImage" src={columnValue.value as string || "/userPlaceholder.svg"} alt="avatar-image" />
												</div>
											);
										}
										case ColumnType.link: {
											return columnValue.value ? (
												<>
													<a href={(columnValue.value as ILinkValue).src} target="_blank" rel="noreferrer" onClick={(event) => event.stopPropagation()}>
														{(columnValue.value as ILinkValue).name}
													</a>
												</>
											) :
												null;
										}
											break;
										case ColumnType.text: {
											return columnValue.value;
										}
										default: {
											return columnValue.value;
										}
									}
								})()}
							</MTableCell>
						);
					})
				}
			</MTableRow>
		);
	}
}
